import "./ExploreAppsCardComponent.scss";
import React from "react";
import { User } from "lucide-react";

interface ExploreAppsCardComponentProps {
    app: any;
    onClick: (appId: string) => void;
}


const ExploreAppsCardComponent: React.FC<ExploreAppsCardComponentProps> = ({app,onClick}) => {
    return (
        <div className="app-card" onClick={()=>{onClick(app.id.toString())}} key={app.id}>
            <div className="app-image">
                <img
                    src={app.image}
                    alt={`${app.name} app`}
                    loading="lazy"
                />
            </div>
            <div className="app-content">
                <h3 className="app-name">{app.name}</h3>
                <div className="app-author">
                    <User className="author-icon" size={14} />
                    {app.author}
                </div>
            </div>
        </div>
    );
};


export default ExploreAppsCardComponent;
